import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    height: 42px;
    border: ${displayState?.completed ? `1px solid ${window?.settings?.primary_color ?? '#1DBD6B'}33` : '1px solid #E3E3E3'};
    border-radius: 48px;
    padding-left: ${displayState?.padding ?? '25px'};
    padding-right: ${displayState?.padding ?? '25px'};
    width: ${displayState?.width ?? ''};
    background: ${displayState?.completed ? `${window?.settings?.primary_color ?? '#1DBD6B'}0D` : '#FFFFFF'};
    
    &:hover {
      border: ${displayState?.disabled ? '' : `1px solid ${theme?.colour?.primary ?? "#1DBD6B"}`};
    }
`}
`;

export default Wrapper(template);